import React from 'react'
import _ from 'lodash'
import { ButtonGroup, Button } from 'react-bootstrap'
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import Control from 'react-leaflet-control'

import NKIcon from '@norkart/ikoner'
import L from 'leaflet'
import {Maalerstatus} from '../utils/statuskoder'
import './popup.css'

let mapStyle = {
    position: 'absolute',
    right: 0,
    left: 0,
    top: 0,
    bottom: 0,
    height: '600px',
    background: 'gray',

}

export default class kart extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            vector: true,
            hybrid: false,
            hideLayerComponent: 'hide'
        }

        this._handleLayerComponentHide = this._handleLayerComponentHide.bind(this)
        this._handleBaseLayer = this._handleBaseLayer.bind(this)
        this._navigerTilSkiftMaaler = this._navigerTilSkiftMaaler.bind(this)
    }

    componentDidMount() {

    }

    _getBounds(maalere) {

        var maxlat = 0;
        var minlat = 90;

        var maxlng = 0;
        var minlng = 90;

        maalere.forEach(function (element) {


            if (element.Latitude > maxlat) {
                maxlat = element.Latitude;
            }
            if (element.Latitude < minlat) {
                minlat = element.Latitude;
            }
            if (element.Longitude > maxlng) {
                maxlng = element.Longitude;
            }
            if (element.Longitude < minlng) {
                minlng = element.Longitude;
            }

        }, this);

        if (maxlat > 0) {

            var southWest = L.latLng(minlat, minlng),
                northEast = L.latLng(maxlat, maxlng),
                bounds = L.latLngBounds(southWest, northEast);
            return bounds;
        }

    }

    _getStart(maalere) {
        var pos;
        {
            maalere.map((st, index) => (
                pos = new L.LatLng(parseFloat(st.Latitude), parseFloat(st.Longitude))
            ))
        }
        return pos;
    }

    _getCustomMarkerIcon(status) {

        var ikon = null;
        
        if(status < Maalerstatus.Skiftet){
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kartikon-planlagt.png',
                iconSize: [40, 40],
            });
        }

        if (status === Maalerstatus.Skiftet) {
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kartikon-utfoert.png',
                iconSize: [40, 40],
            });
        } 

        if (status === Maalerstatus.IkkeSkiftet) {
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kart_ikkeskiftet.png',
                iconSize: [40, 40],
            });
        }
        return ikon;
    }

    _getRiktigDatoformat(d) {
        var arrDato = ('' + d).split("T");
        var aar = arrDato[0].split("-");
        var tid = arrDato[1].split(":");
        var resultat = aar[2] + "." + aar[1] + "." + aar[0] + " kl:" + tid[0] + ":" + tid[1];
        return resultat;
    }

    _handleLayerComponentHide() {
        var hide = this.state.hideLayerComponent;
        if (hide === 'hide') {
            this.setState({ hideLayerComponent: ' ' });
        } else {
            this.setState({ hideLayerComponent: 'hide' });
        }
    }

    _handleBaseLayer(changeEvent) {
        var lay = changeEvent.target.value;

        switch (lay) {
            case 'vector':
                this.setState({
                    vector: true,
                    hybrid: false
                })
                break
            case 'hybrid':
                this.setState({
                    vector: false,
                    hybrid: true
                })
                break
            default: this.setState({
                vector: true,
                hybrid: false
            })
        }
    }

    _navigerTilSkiftMaaler(changeEvent) {        
        var maalerId = changeEvent.target.value;
        this.props.navigerTilSkiftMaaler(maalerId)
    }

    _opprettMappopup(){

    }

    render() {
        let zoom = 10;
        let maalereSomSkalVises = _.filter(this.props.vannmaalere, m => m.Latitude > 0)
      
        let map = <Map center={this._getStart(maalereSomSkalVises)} zoom={zoom} maxZoom={20} zoomControl={false}
            style={mapStyle} bounds={this._getBounds(maalereSomSkalVises)} boundsOptions={{ padding: [50, 50] }}>
            {this.state.vector &&
                <TileLayer url="//www.webatlas.no/maptiles/tiles/webatlas-gray-vektor/wa_grid/{z}/{x}/{y}.png" maxZoom={20} />}

            {this.state.hybrid &&
                <TileLayer url="//www.webatlas.no/maptiles/tiles/webatlas-standard-hybrid/wa_grid/{z}/{x}/{y}.jpeg" maxZoom={20} />}

            <Control position="topleft" >
                <div>
                    <button type="button" className="btnLag" onClick={this._handleLayerComponentHide}>
                        <NKIcon icon="lag" color="nk-black" />
                    </button>
                    <div className={'layerComponent ' + this.state.hideLayerComponent}>
                        <button type="button" value="vector" onClick={this._handleBaseLayer} className='btn btn-primary w150'>Kart</button> <br />
                        <button type="button" value="hybrid" onClick={this._handleBaseLayer} className='btn btn-default w150'>Flyfoto</button> <br />
                    </div>
                    <br />
                </div>
            </Control>
               
            {maalereSomSkalVises
                .map((maaler, index) => (
                      
                        <Marker position={[maaler.Latitude, maaler.Longitude]} icon={this._getCustomMarkerIcon(maaler.Status)}
                        key={maaler.MaalerId}>
                        <Popup position={[maaler.Latitude, maaler.Longitude]} className='vat-popup'>
                            <div>
                                <h4>Målerinformasjon</h4>
                                <table className='Table' width='200px'>
                                    <tbody>
                                        <tr>
                                            <td>Eier:</td><td>{maaler.Eiernavn}</td>
                                        </tr>
                                        <tr>
                                            <td>Adresse:</td><td>{maaler.Maalepunktadresse} {maaler.Husnummer}</td>
                                        </tr>
                                        <tr>
                                            <td>Mob:</td><td>{maaler.Mobil}</td>
                                        </tr>
                                        <tr>
                                            <td>Avtalt tid:</td><td>{this._getRiktigDatoformat(maaler.Avtaltdato)}</td>
                                        </tr>
                                        <tr>
                                            <td>Avlesertype:</td><td>{maaler.Avlesertype}</td>
                                        </tr>
                                        <tr>
                                            <td>Plassering:</td><td>{maaler.Plassering}</td>
                                        </tr>                                       
                                    </tbody>

                                </table>
                                {(maaler.Status < 3 && this.props.viseKnappForMaalerskifte) ?
                                    <ButtonGroup vertical block>
                                        <Button bsStyle="primary" value={maaler.MaalerId} onClick={this._navigerTilSkiftMaaler}>Skift måler</Button>
                                    </ButtonGroup>
                                    : <div/>
                                }
                            </div>
                        </Popup>
                    </Marker>
                    
                    
                ))}
        </Map>

        return (

            <div className="modal-content" >
                <div className="modal-header">
                    <button className="close" onClick={this.props.onClose} type="button">
                        <span>x</span>
                        <span className="sr-only">Lukk</span>
                    </button>
                    <h4 className="modal-title">{this.props.tittel}</h4>
                </div>

                <div className="modal-body">
                    <div style={mapStyle} >
                        {map}

                    </div>
                </div>
            </div>
        )





    }
}




// WEBPACK FOOTER //
// ./src/felles/Kart/kart.jsx